import type { ReactNode } from "react";

/*
 * 文字用 800 不用 700：700 在 -50 浅底上只有 3.1~3.9:1，不到 AA 的 4.5:1。
 * 横幅是运营判断「这页配错了会怎样」的主要来源，是最不该看不清的字。
 */
const TONE = {
  warning: "bg-warning-50 border-warning-200 text-warning-800",
  danger: "bg-danger-50 border-danger-200 text-danger-800",
  info: "bg-primary-50 border-primary-100 text-primary-800",
  success: "bg-success-50 border-success-200 text-success-800",
  plain: "bg-fill-light border-line-lighter text-ink-regular",
} as const;

export function Notice({
  tone = "warning", children, actions,
}: { tone?: keyof typeof TONE; children: ReactNode; actions?: ReactNode }) {
  return (
    <div className={`flex items-center justify-between gap-3 rounded-base border px-3 py-2 text-sm ${TONE[tone]}`}>
      <div className="leading-relaxed">{children}</div>
      {actions && <div className="flex flex-none gap-2">{actions}</div>}
    </div>
  );
}
